const { default: axios } = require('@/libs/axios')

const IndustryItemsService = {
  // GET - IndustryApiController
  async getAdminIndustries() {
    return axios.get('/admin/industries').then(response => response.data)
  },
  // POST - IndustryApiController
  async createIndustry(model) {
    return axios.post('/admin/industries', model).then(response => response.data)
  },
  // PUT - IndustryApiController
  async updateIndustry(industryId, model) {
    return axios.put(`/admin/industries/${industryId}`, model).then(response => response.data)
  },
  // DELETE - IndustryApiController
  async deleteIndustry(industryId) {
    return axios.delete(`/admin/industries/${industryId}`).then(response => response.data)
  },
  // GET - IndustryApiController
  async getParentIndustries() {
    return axios.get('/admin/industries/parent').then(response => response.data)
  },
}

export default IndustryItemsService
